// extracted by mini-css-extract-plugin
export var container = "_mm-0";
export var dotAnimation = "_mm-2";
export var dotsLoading = "_mm-1";